import { Reveal } from "./Reveal";

const Elegancia = ({ t }) => (
  <section className="elegancia grain" id="elegancia" data-testid="elegancia-section">
    <div className="wrap">
      <Reveal>
        <i className="diamond eleg-diamond" aria-hidden="true" />
        <p className="eyebrow">{t.elegLabel}</p>
        <h2 className="eleg-title">{t.elegTitle}</h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="eleg-text">{t.elegText1}</p>
        <p className="eleg-text">{t.elegText2}</p>
      </Reveal>
      <Reveal delay={0.2}>
        <a className="btn-gold" href="#contact" data-testid="elegancia-cta">
          {t.elegCta} <span className="arr">↗</span>
        </a>
      </Reveal>
    </div>
  </section>
);

export default Elegancia;
